import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {  SizingTypeValue } from "../../../types/enums";

const styles = {
  select: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    minHeight: "38px",
    height: "38px",
    maxHeight: "38px",
    fontSize: "14px",
    width: "100%",
  },
};

export default function DropDown(props: any) {
  const {
    data,
    errorMsg,
    handleChange,
    field,
    sectionName,
    value,
    currentObjFieldError,
    propertyId,
    unitId,
    isApplicationSubmitted,
    loanDetails,
    dynamicConfig,
    currentObjValue
  } = props;
  const { t } = useTranslation();

  // Local buffer, same reasoning as TextFieldComponent — `value` round-trips
  // through LoansContext before this Select would otherwise reflect a
  // selection, which reads as a delay closing the menu/showing the pick.
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <div>
      <FormControl
        variant="outlined"
        sx={{
          width: "100%",
          height: "38px",
          "@media (max-width: 600px)": { width: "100%" },
        }}
      >
        <Select
          className={`app-theme-data-points truncate-words p-4 br-6 ${
            currentObjFieldError && !!errorMsg && "app-theme-data-points-error"
          } `}
          displayEmpty
          input={<OutlinedInput />}
          autoWidth
          value={localValue ?? "none"}
          onChange={(ele) => {
            // flushSync — see TextFieldComponent for why this is needed to
            // avoid React 18 batching this with LoansContext's heavier
            // update. (startTransition was also tried, to yield/paint in
            // between, but caused hangs under rapid input — reverted.)
            const newValue = ele.target.value;
            flushSync(() => setLocalValue(newValue));
            handleChange(
              newValue,
              "dropDown",
              field,
              sectionName,
              propertyId,
              unitId
            );
          }}
          sx={styles.select}
          placeholder="Select"
          disabled={
            dynamicConfig?.allowEditAfterSubmit &&
            !(
              field?.isAutoCalculated &&
              field?.isAutoCalculated({
                sizingType: loanDetails?.sizingType,
              })
            )
              ? false
              : isApplicationSubmitted ||
                field?.isAutoCalculated({ sizingType: loanDetails?.sizingType })
          }
        >
          <MenuItem value="none" disabled sx={{ fontSize: "14px" }}>
            Select
          </MenuItem>
          {data?.filter((ele: any) => ele?.isHidden ? ele?.isHidden?.({ isSizingTypeValid: loanDetails?.sizingType === SizingTypeValue?.QUICK_LOAN_SIZING, prepayMonths: currentObjValue?.prepaymentPenaltyTypeMonths }) : true)?.map((ele: any) => {
            return (
              <MenuItem key={ele.label} value={ele.value} sx={{ fontSize: "12px" }}>
                {t(ele.label)}
              </MenuItem>
            );
          })}
        </Select>
        {currentObjFieldError ? (
          <FormHelperText className="break-word">{t(errorMsg)}</FormHelperText>
        ) : null}
      </FormControl>
    </div>
  );
}
